import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import Ad from "./Ad";
import Apply from "../pages/apply";
import BugReport from "../pages/bug-report";
import Clipboard from "./Clipboard";
import ContactUs from "../pages/contact-us";
import Default from "../pages/default";
import Footer from "./Footer";
import GoogleAnalytics from "react-ga";
import Index from "../pages/index";
import Leaderboard from "./Leaderboard";
import Navbar from "./Navbar";
import Privacy from "../pages/privacy";
import Recs from "../pages/recs";
import styles from "../styles/Routes.module.scss";
import { useLocation } from "react-router-dom";

GoogleAnalytics.initialize("UA-64784451-1");

const Routes = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    GoogleAnalytics.set({
      page: pathname + search,
    });
    GoogleAnalytics.pageview(pathname + search);
  }, [pathname, search]);

  return (
    <div className={styles.containerOuter}>
      <div className={styles.container}>
        <Clipboard />
        <Navbar />
        <div>
          <Leaderboard />
          <Switch>
            <Route exact path="/">
              <Index />
            </Route>
            <Route path="/apply">
              <Apply />
            </Route>
            <Route path="/bug-report">
              <BugReport />
            </Route>
            <Route path="/contact-us">
              <ContactUs />
            </Route>
            <Route path="/privacy">
              <Privacy />
            </Route>
            <Route path="/recs">
              <Recs />
            </Route>
            <Switch>
              <Route path="/:dir?/:page?/:subpage?">
                <Default />
              </Route>
            </Switch>
          </Switch>
        </div>
      </div>
      <Footer />
      <Ad id="mobile" />
      <Ad id="mobile_a" />
    </div>
  );
};

export default Routes;
